import {
  addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  type Timestamp,
  type Unsubscribe,
} from "firebase/firestore";
import { db } from "@/config/firebase";

export interface StudioMarker {
  readonly id: string;
  readonly label: string;
  readonly time_seconds: number;
  readonly created_at?: Timestamp;
}

export interface CreateStudioMarkerInput {
  readonly label: string;
  readonly time_seconds: number;
}

function markersRef(projectId: string) {
  return collection(db, "projects", projectId, "studio_markers");
}

export function subscribeStudioMarkers(
  projectId: string,
  onData: (markers: StudioMarker[]) => void,
  onError: (error: Error) => void,
): Unsubscribe {
  const markersQuery = query(markersRef(projectId), orderBy("time_seconds", "asc"));
  return onSnapshot(
    markersQuery,
    (snapshot) => {
      onData(snapshot.docs.map((document) => ({ id: document.id, ...document.data() }) as StudioMarker));
    },
    onError,
  );
}

export async function createStudioMarker(projectId: string, input: CreateStudioMarkerInput): Promise<string> {
  const docRef = await addDoc(markersRef(projectId), {
    label: input.label,
    time_seconds: Math.max(0, Math.floor(input.time_seconds)),
    created_at: serverTimestamp(),
  });
  return docRef.id;
}
